import { ProviderSidebar } from "@/components/layout/ProviderSidebar";
import { ProviderHeader } from "@/components/layout/ProviderHeader";
import { PNCCCaseList } from "@/components/prenatal/provider/PNCCCaseList";

export default function PrenatalCareCoordination() {
  return (
    <div className="min-h-screen bg-background">
      <ProviderSidebar />
      <div className="ml-64">
        <ProviderHeader />
        <main className="p-6">
          <div className="mb-6">
            <h1 className="font-display text-3xl font-bold text-foreground">
              Prenatal Care Coordination (PNCC)
            </h1>
            <p className="mt-1 text-muted-foreground">
              Manage PNCC intake forms, care plans, and monthly time logs for ForwardHealth members
            </p>
          </div>
          <PNCCCaseList />
        </main>
      </div>
    </div>
  );
}
